<template>
  <div class="patient-type section">
    <ul class="patient-type-list">
      <li v-if="content.getGenderIcon()" class="patient-type-item">
        <p class="title">genre</p>
        <p class="description gender" v-html="$sanitize(content.getGenderIcon())"></p>
      </li>
      <li class="patient-type-item">
        <p class="title">Age</p>
        <p class="description">
          {{ content.getTextAge() }}
          <span v-if="content.getAgeUnit()" class="unit">{{ content.getAgeUnit() }}</span>
        </p>
      </li>
      <li v-if="content.getDate().start" class="patient-type-item">
        <p class="title">Recrutement</p>
        <p class="description">
          <span class="text-small">{{ content.getTextDate() }}</span>
          <span>{{ content.getDate().start }}</span>
        </p>
      </li>
      <li v-if="content.getPhase()" class="patient-type-item">
        <p class="title">Phase</p>
        <p class="description">
          {{ content.getPhase() }}
        </p>
      </li>
      <li v-if="content.getDistance()" class="patient-type-item">
        <p class="title">Distance minimum</p>
        <p class="description">
          {{ content.getDistance() }}
          <span> ({{ content.getDistanceUnit() }}) </span>
        </p>
      </li>
    </ul>
    <div v-if="hasUrl && clinicalPatientTypeDetail && content.getUrl()" class="center-content">
      <a
        :href="content.getUrl()"
        @click="setOriginSearch"
        class="btn-see-more btn-type2">
          Voir plus
      </a>
    </div>
  </div>
</template>

<script>
import { ClinicalResultsItemModel } from '@/models';
import { setOriginSearch } from '@/helpers';

export default {
  props: {
    content: {
      type: ClinicalResultsItemModel,
      required: true,
    },
    hasUrl: {
      type: Boolean,
      default: true,
    },
    clinicalPatientTypeDetail: {
      type: Boolean,
      default: true,
    },
  },
  setup() {
    return {
      setOriginSearch,
    };
  },
};
</script>

<style scoped>

.bold {
  font-weight: 700;
}
</style>
